export enum SettingsActionTypes {
  ACTION_CHANGE_SETTING = 'ACTION_CHANGE_SETTING',
}
